var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.656,
    height: 25.656,
    viewBox: "0 0 25.656 25.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loginEyeOff",
    transform: "translate(-0.086 -0.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M19.077,20.464A10.449,10.449,0,0,1,12.914,22.6C5.65,22.6,1.5,14.3,1.5,14.3A19.144,19.144,0,0,1,6.75,8.137m3.984-1.888A9.463,9.463,0,0,1,12.914,6c7.263,0,11.414,8.3,11.414,8.3a19.2,19.2,0,0,1-2.241,3.31M15.113,16.5a3.113,3.113,0,1,1-4.4-4.4",
    transform: "translate(0 -1.387)",
    fill: "none",
    stroke: "#bd8ef2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M1.5,1.5,24.327,24.327",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#bd8ef2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEyeOff);
export default __webpack_public_path__ + "static/media/loginEyeOff.60fd85c8b6fff2c00c3df9ccbac02e8f.svg";
export { ForwardRef as ReactComponent };